/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';

type ReactRef<T> = {
  current: T | null;
};

type WPState = {
  width: number;
};

/*
 * A simple HOC that provides facility for listening to container resizes.
 */
export default function WidthProvideRGL(ComposedComponent: any): any {
  return class WidthProvider extends React.Component<any, WPState> {
    elementRef: ReactRef<HTMLDivElement> = React.createRef();

    constructor(props: any) {
      super(props);
      this.state = { width: 0 };
    }

    componentDidMount() {
      this.setState({ width: 0 });

      window.addEventListener('resize', this.onWindowResize);
      this.onWindowResize();
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onWindowResize);
    }

    onWindowResize = () => {
      const node = this.elementRef.current;
      if (node instanceof HTMLElement && node.offsetWidth) {
        this.setState({ width: node.offsetWidth });
      }
    };

    render() {
      const { ...rest } = this.props;
      return (
        <>
          <ComposedComponent innerRef={this.elementRef} {...rest} {...this.state} />
        </>
      );
    }
  };
}
